import { ApiError } from "pages/admin-app/shared/models/response/api-errors";
import { useQuery } from "@tanstack/react-query";
import { GetDistributorResponse } from "../models/response/get-distributor-response";
import { getDistributor } from "../services/distributor-service";

interface Props {
  distributorId: number | string;
}

export function useDistributor({ distributorId }: Props) {
  const { data, error, isLoading, isError, refetch } = useQuery<
    GetDistributorResponse,
    ApiError
  >({
    queryKey: ["distributor", distributorId],
    queryFn: () => getDistributor({ distributorId }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
  };
}
